<div class="headerWrapper">
    <!-- <div class="title">HI fellow americans.</div> -->
    <!-- <div class="headerBg" *ngIf="isDasboard"> -->
    <!-- </div> -->


    <div class="left">
        <a routerLink="/" routerLinkActive="router-link-active" [ngClass]="{disabled: isDasboard}">
            <div class="logoHolder">
                <img class="logo" src="assets/Lionsgate-Repertory-logo.png" alt="">
                <img class="logoOver" src="assets/Lionsgate-Repertory-logo-rollover.png" alt="">
            </div>
        </a>
    </div>
    <!-- page header -->
    <div class="right" *ngIf="!isDasboard">
        <a routerLink="/">Home</a>
        <!-- <a routerLink="/all-films">All Films</a> -->
        <a routerLink="/search" >Advanced Search</a>
        <a routerLink="/profile/wishlist" class="profileLink">
            <div class="imgHolder">
                <img class="out" src="assets/profile-icon.png" alt="">
                <img class="over" src="assets/profile-icon-rollover.png" alt="">
            </div>
        </a>
    </div>
    <!-- dashboard -->
    <div class="center" *ngIf="isDasboard">
        <div class="label">DASHBOARD</div>
    </div>
    <div class="right" *ngIf="isDasboard">
        <a routerLink="/dashboard/accounts/requests" routerLinkActive="router-link-active">Accounts</a>
        <a routerLink="/dashboard/bookings/requests" routerLinkActive="router-link-active">Bookings</a>
        <a (click)="logout()" class="logout" routerLinkActive="router-link-active">LOGOUT</a>
        <!-- <a routerLink="/all-films">All Films</a> -->
        
    </div>

</div>